import { render, staticRenderFns } from "./DealerDetail.vue?vue&type=template&id=733276ec&scoped=true"
import script from "./DealerDetail.vue?vue&type=script&lang=js"
export * from "./DealerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733276ec",
  null
  
)

export default component.exports